import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormWarningAlert } from 'components/reusables/formWarningAlert'

interface InactiveCourseLessonsAlertProps {
  className?: string
}

export const InactiveCourseLessonsAlert: React.FC<InactiveCourseLessonsAlertProps> =
  ({ className }) => {
    const { t } = useTranslation()

    return (
      <FormWarningAlert
        className={className}
        message={t('administration.lessons.inactiveCourseAlert')}
      />
    )
  }
